import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLockOpen24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.962 3.65c-.594.132-1.114.368-1.41.733a13 13 0 0 0-.496.64.75.75 0 0 1-1.4-.5l.735.154c-.734-.154-.734-.156-.733-.158v-.004l.002-.007.004-.015a.8.8 0 0 1 .09-.216 2 2 0 0 1 .103-.156c.088-.124.244-.33.53-.683.612-.755 1.533-1.093 2.248-1.252a7.2 7.2 0 0 1 1.607-.166h.041l.078.001a5.12 5.12 0 0 1 5.12 5.12v.897A3 3 0 0 1 20 11v7a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h8.98v-.86a3.62 3.62 0 0 0-3.62-3.619l-.113-.001h-.027a5.8 5.8 0 0 0-1.259.13M17 9.5H7A1.5 1.5 0 0 0 5.5 11v7A1.5 1.5 0 0 0 7 19.5h10a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 17 9.5m-3.5 4.54a1.5 1.5 0 0 1-.772 1.311q.04.116.041.246v.807a.75.75 0 1 1-1.5 0v-.807q0-.12.035-.228a1.5 1.5 0 1 1 2.196-1.33"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen24);
